import routerOptions0 from "/app/node_modules/.pnpm/nuxt@4.1.2_@parcel+watcher@2.5.1_@types+node@24.4.0_@vue+compiler-sfc@3.5.21_db0@0.3.2_eslint_b34kuxyevtmennltgflzsv3w6q/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}